import { Component, Input, forwardRef } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { UserService } from '../../../services/user.service';
import { CACHE_KEYS } from '../../../contants/CACHE_KEYS';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
	selector: 'ztsi-user-select',
	templateUrl: './ztsi-user-select.component.html',
	styleUrls: ['./ztsi-user-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiUserSelectComponent),
			multi: true
		}
	]
})
export class ZtsiUserSelectComponent implements ControlValueAccessor {
	users: KeyValuePair[] = [];
	
	@Input('value') _value: string;
	@Input() role: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _userService: UserService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		let cacheKey = `USERS_${this.role}`;
		this._userService.getUsersDropdownList(cacheKey, this.role).subscribe(response => {
			if (response.length != undefined) {
				this.users = response;
				// if (this.value === null && this.users.length > 0) {
				// 	this.value = this.users[0].key;
				// }
			}
			else {
				console.log(`Unable to load user selection for role: '${this.role}'.`);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-user-select/ztsi-user-select.component.ts